import { AuthUser } from 'app/provider/auth'
import { GroupPostCreationModal } from '../group-post-creation-modal'
import { GroupAnnouncement } from 'app/types'
import { format } from 'date-fns'
import {
  AnnouncementCreationView,
  AnnouncementFormData,
  SubmitAnnouncementData,
} from './announcement-creation-view'

export interface GroupAnnouncementEditWizardProps {
  open: boolean
  user: Pick<AuthUser, 'id' | 'fullName' | 'avatar' | 'token'>
  announcement: GroupAnnouncement
  submitting: boolean
  onOpenChange: (value) => void
  onSubmit: (data: SubmitAnnouncementData) => void
}

export const GroupAnnouncementEditWizard = (props: GroupAnnouncementEditWizardProps) => {
  const { announcement } = props

  const defaultValues: AnnouncementFormData = {
    title: announcement.title,
    body: announcement.body,
    ...(announcement.scheduledDate && {
      scheduledDate: format(new Date(announcement.scheduledDate), 'yyyy-MM-dd'),
      scheduledTime: format(new Date(announcement.scheduledDate), 'HH:mm'),
    }),
  }

  return (
    <GroupPostCreationModal key="Edit modal" open={props.open} onOpenChange={props.onOpenChange}>
      <AnnouncementCreationView
        title="Edit announcement"
        user={props.user}
        onOpenChange={props.onOpenChange}
        onSubmit={props.onSubmit}
        isSubmitting={props.submitting}
        defaultValues={defaultValues}
        selectedGroup={announcement.group}
        isEditing
      />
    </GroupPostCreationModal>
  )
}
